import { FC } from 'react'

import { VStack } from '@revolut-internal/ui-kit'

import { QueuesHealthDetails } from './QueuesHealthDetails'
import { TicketsVolumeDetails } from './TicketsVolumeDetails'

export const Ticket: FC = () => {
  return (
    <VStack space="s-16">
      <QueuesHealthDetails />
      <TicketsVolumeDetails />
    </VStack>
  )
}
